var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`atlas-text-sm atlas-h-full atlas-w-full 
  ${_vm.isSiteReport ? 'atlas-block' : 'atlas-flex'}`,attrs:{"id":"app"}},[_c('router-view'),(_vm.user && !_vm.isExcluded && !_vm.isImpersonation && _vm.user._id && _vm.user._account._id)?_c('multi-device-block'):_vm._e(),_c('HotJarSnippet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }